import { Children, isValidElement } from 'react';
import { Falcon } from 'modules/macro';
import { Menu } from 'modules/v2';
import { NestedBreadcrumb } from '../BreadcrumbNested';
import { Container, ItemContainer } from '../styled';
import { StyledIconButton } from './styled';
const START_OFFSET = 1;
const END_OFFSET = 2;
export function BreadcrumbsMenu(props) {
    const { children } = props;
    const items = Children.toArray(children);
    const first = items.slice(0, START_OFFSET);
    const middle = items.slice(START_OFFSET, items.length - END_OFFSET);
    const last = items.slice(Math.max(items.length - END_OFFSET, 1));
    const renderNestedBreadcrumb = (child) => {
        if (isValidElement(child)) {
            const childProps = child.props;
            return <NestedBreadcrumb {...childProps}/>;
        }
        return null;
    };
    return (<Container>
      {first}

      <ItemContainer>
        <Menu.Root target={<StyledIconButton size="xs" appearance="ghost">
              <Falcon icon="ellipsis"/>
            </StyledIconButton>}>
          {Children.map(middle, renderNestedBreadcrumb)}
        </Menu.Root>
        <Falcon icon="chevron-right" $size={10}/>
      </ItemContainer>

      {last}
    </Container>);
}
